import React from 'react';
import './Card.css';

class Card extends React.Component {
  render() {
    // const getEvent = this.props.showDetails
    const items = this.props.data.map((item, id) => {
      const { url = '', title = '' } = item;
      const imageName = `${title.replace(/ /g, '-').replace('&', 'and').toLowerCase()}`;
      const backgroundImage = {
        backgroundImage: `url(/img/logos/${imageName}.jpg)`
      };

      return (
        <div className="card-item" key={id}>
          {/* <a className="card-item-link" onClick={getEvent.bind(this, id)}> */}
          <a
            rel="noreferrer"
            href={url}
            target="_blank"
            className="card-item-link"
            aria-label={title}
          >
            <div className="card-item-image" style={backgroundImage} />
            <h3 className="card-item-title">{title}</h3>
            <h4 className="card-item-subtitle">{item.type}</h4>
          </a>
        </div>
      )
    })

    return <div className="card">{items}</div>
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/Shared/Card.js